import React from "react";
import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import "./epicbutton.scss";
import addEpicIcone from "../../../../../styles/svg/add-epic.svg";
import addIcon from "../../../../../styles/svg/group-plus-icon.svg";
import AddMilestone from "../../../../../components/Milestone/addMilestone";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { useCreateMilestoneDialog } from "../../../../../components/Milestone/hooks/useCreateMilestoneDialog";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { TooltipName } from "../../../../../utils/Enums";
import { CustomButton } from "../../../../../components/Button/Button";

const CreateEpic = ({ isTab = false }) => {
  const {
    handleClickOpen,
    handleClose,
    openCreateMilestoneDialog,
  } = useCreateMilestoneDialog();
  const isMobile = useResponsive("down", "md");

  return (
    <>
      {isTab ? (
        <Tooltip title={TooltipName.BOARD_PAGE.CREATE_NEW_MILESTONE}>
        <CustomButton
          size="small"
          className="create-card-btn reset-btn"
          onClick={handleClickOpen}
        >
          <AddIcon className="add-icon" />
        </CustomButton>
        </Tooltip>
      ) : (
        <div
          className="create-epic-btn"
          onClick={handleClickOpen}
        >
          {isMobile ? (
            <img src={addIcon} alt="create milestone" />
          ) : (
            <CustomButton
              className="create-epic-button"
              variant="contained"
            >
              <img src={addEpicIcone} alt="add milestone" /> Create New
            </CustomButton>
          )}
        </div>
      )}

      {openCreateMilestoneDialog && (
        <FormDialog
          open={openCreateMilestoneDialog}
          handleClose={handleClose}
          title={"Create Milestone"}
          width={613}
          fullWidth={true}
        >
          <AddMilestone onClose={handleClose} />
        </FormDialog>
      )}
    </>
  );
};

export default CreateEpic;
